export const menuList = [
  {
    title:'首页',
    path: '/',
    name: 'home',
    isChildren: false
  },
  {
    title:'解决方案',
    path: '/product',
    name: 'product',
    ref:'product',
    isChildren: true
  },
  {
    title:'产品中心',
    path: '/device',
    name: 'device',
    ref:'deviceMenu',
    isChildren: true
  },
  {
    title:'经典案例',
    path: '/case',
    name: 'case',
    ref:'case',
    isChildren: false
  },
  // {
  //   title:'智慧消防',
  //   path: '/smartFire',
  //   name: 'smartFire',
  //   isChildren: false,
  //   isHot: false
  // },
  // {
  //   title:'生态合作',
  //   path: '/cooperation',
  //   name: 'cooperation',
  //   isChildren: false
  // },
  {
    title:'关于我们',
    path: '/about',
    name: 'about',
    isChildren: false
  }
]


// WEBPACK FOOTER //
// ./src/views/components/common.js